/* eslint-disable array-callback-return */
import {
    Accidental,
    Flow,
    FormatParams,
    Formatter,
    RenderContext,
    Renderer,
    Voice,
} from 'vexflow4';
import { formatStavesToJson } from '../../utils/helpers';
import { StaveNote } from '../../common/extension/MusiconStaveNote';
import Stave from '../../common/extension/MusiconStave';

export default class optionHandler {
    public static instance: optionHandler | null = null;
    private render: Renderer;
    private ctx: RenderContext;
    private _stave: Stave;
    private provisoryTickable: StaveNote | null = null;
    public duration: string = '4';
    private dragCursorX: number | null = null;
    private currentNoteCursorX: number | null = null;
    private currentBarIndex: number | undefined = undefined;

    public currentStave: Stave | null = null;
    public currentNote: StaveNote | null = null;

    public playing: boolean = false;

    private melodyHeadStave;
    private head_stave_width;
    private padding_horizontal;
    private padding_top;
    private start_of_stave;
    private content_stave_width;


    private redrawCallback: (data: string) => void = (data: string) => {
    };


    public constructor(render: Renderer) {
        const yincheng_tone = localStorage.getItem('question_selection_key') || 'C';
        this.head_stave_width = yincheng_tone === 'C' ? 40 : 110;
        this.padding_horizontal = 0;
        this.padding_top = 0;
        this.start_of_stave = this.head_stave_width + this.padding_horizontal;
        this.content_stave_width = yincheng_tone === 'C' ? window.innerWidth * 0.7 : window.innerWidth * 0.5;

        this.render = render;
        this.ctx = render.getContext();
        const stave = new Stave(this.start_of_stave, this.padding_top, this.content_stave_width);
        stave.setBegBarType(7);
        this._stave = stave;
        this.currentStave = stave;
        this.melodyHeadStave = new Stave(this.padding_horizontal, this.padding_top, this.head_stave_width)
    }

    public setRedrawCallback = (callback: (data: string) => void) => {
        this.redrawCallback = callback;
    }

    public get stave(): Stave {
        return this._stave;
    }

    public set stave(stave: Stave) {
        this._stave = stave;
    }

    public init = () => {
        this.redraw();
    };

    public redraw = () => {
        const data = JSON.stringify(formatStavesToJson([this.stave]));
        this.redrawCallback(data);

        this.ctx.clear();
        this._drawHeads();
        this._drawDragCursor();
        this._drawNoteCursor();
        this._drawStaves();
        this._drawNotes();
        this._drawProvisoryTickable();
    };

    private _drawHeads = () => {
        const yincheng_tone = localStorage.getItem('question_selection_key') || 'C';

        const mhs = new Stave(this.padding_horizontal, this.padding_top, this.head_stave_width);
        mhs.addClef('treble');

        mhs.setEndBarType(7);
        mhs.setKeySignature(yincheng_tone);

        mhs.setContext(this.ctx).draw();
        this.melodyHeadStave = mhs;
    };

    private _drawDragCursor = () => {
        try {

            if (!this.dragCursorX || !this.currentStave) {
                return;
            }

            const tempFillStyle = this.ctx.fillStyle;
            this.ctx.fillStyle = 'rgba(255, 241, 212, 0.80)';

            const space = this.currentStave.getSpacingBetweenLines();
            const x = this.dragCursorX - space / 2;
            const y = 0;
            const w = space * 2;
            const h = 240;

            this.ctx.fillRect(x, y, w, h);

            this.ctx.fillStyle = tempFillStyle;
        } catch (e) {
            console.log('>>> _drawDragCursor error: ', e);
        }
    };

    private _drawNoteCursor = () => {
        try {
            const x = this.currentNoteCursorX;
            const stave = this.currentStave;

            this.currentBarIndex = undefined;

            if (!stave || !x) return;

            const space = stave.getSpacingBetweenLines();
            const y = stave.getTopLineTopY();
            const w = space * 2;
            const h = space * 4;

            const tempFillStyle = this.ctx.fillStyle;

            this.ctx.fillStyle = '#FDE3AF';
            this.ctx.fillRect(x - space / 2, y, w, h);
            // 找到当前选中的小节编号
            if (this.currentStave?.getY() === 20) {
                this.currentBarIndex = (this.currentStave?.getX() - 135) / 150;
            }

            this.ctx.fillStyle = tempFillStyle;
        } catch (e) {
            console.log('>>> _drawNoteCursor error: ', e);
        }
    };

    private _drawStaves = () => {
        try {
            [this.stave].forEach((stave: Stave) => {
                stave.setContext(this.ctx).draw();
            });
        } catch (e) {
            console.log('>>> _drawStaves error: ', e);
        }
    };

    private _drawNotes = (stave?: Stave) => {
        try {

            if (stave === undefined) {
                [this.stave].forEach((stave) => {
                    this._drawNotes(stave);
                });
            } else {
                const voice = new Voice(Flow.TIME4_4).setMode(Voice.Mode.SOFT);
                const notes = stave.getTickables().map((note: StaveNote) => {
                    note.setCenterAlignment(false);
                    note.setWidth(25);
                    return note;
                });
                voice.addTickables(notes);

                const formatter = new Formatter();
                const formatOption = {
                    align_rests: true,
                    auto_beam: true,
                    width: 50,
                    minSpace: 50,
                } as FormatParams;

                formatter.joinVoices([voice]);

                if (stave.getTickables().length > 0) {
                    formatter.formatToStave([voice], stave, formatOption);
                }
                voice.draw(this.ctx, stave);
            }
        } catch (e) {
            console.log('>>> _drawNotes error: ', e)
        }
    };

    private _drawProvisoryTickable = () => {
        try {
            if (!this.currentStave) return;
            if (!this.provisoryTickable) return;

            //Only draw Provisory note if not on a definitive note
            const tempFillStyle = this.ctx.fillStyle;
            const tempStrokeStyle = this.ctx.strokeStyle;
            this.ctx.fillStyle = 'gray';
            this.ctx.strokeStyle = 'gray';

            this.provisoryTickable.setStave(this.currentStave);
            this.provisoryTickable.draw();

            this.ctx.fillStyle = tempFillStyle;
            this.ctx.strokeStyle = tempStrokeStyle;
        } catch (e) {
            console.log('>>> _drawProvisoryTickable error: ', e)
        }
    };

    public setStaveNotes = (notes: any[]) => {
        const newNotes = notes.map(
            ({
                 keys,
                 duration,
                 accidentals,
             }: {
                keys: string[];
                duration: string;
                accidentals: string[];
            }) => {
                const note = new StaveNote({ keys, duration });

                note.autoStem();

                accidentals.map((accidental: any): void => {
                    if (accidental === null) {
                        return;
                    }

                    if (typeof accidental === 'string') {
                        note.addModifier(new Accidental(accidental), 0);
                        return;
                    }

                    const index = accidental.index;

                    note.addModifier(new Accidental(accidental.modifier), index);
                });

                return note;
            },
        );
        this.stave.setTickables(newNotes);

        this.redraw();
    }
}
